import { Button } from '@longy/web-components'
import { Link } from '@tanstack/react-router'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'

import { resolveWebinarCtaState } from '../../utils/webinarCta'

export const WebinarCtaButton = ({
    purchasableItemId,
    isBooked,
    freePlaces,
    size = 'sm',
}: {
    purchasableItemId: string
    isBooked: boolean
    freePlaces: number
    size?: 'sm' | 'default' | 'lg'
}): ReactElement => {
    const { t } = useTranslation()

    // `asChild` renders the button as the anchor, and an anchor ignores `disabled` — a sold-out
    // session was clickable all the way to a checkout that refuses it after the billing form. A
    // full session, and one this person already holds, get a real button instead of a link.
    return (
        match(resolveWebinarCtaState({ isBooked, freePlaces }))
            .with('booked', () => (
                <Button disabled size={size}>
                    {t('frontend.catalog.alreadyBooked')}
                </Button>
            ))
            .with('soldOut', () => (
                <Button disabled size={size}>
                    {t('frontend.catalog.soldOut')}
                </Button>
            ))
            // A webinar session is a single slot, so it goes straight to checkout — no expert or
            // time left to choose.
            .with('bookable', () => (
                <Button asChild size={size}>
                    <Link to="/booking/checkout" search={{ purchasableItemId }}>
                        {t('frontend.catalog.bookNow')}
                    </Link>
                </Button>
            ))
            .exhaustive()
    )
}
